module.exports = __webpack_public_path__ + "static/media/HK First Responder v4 (CH-ENG) eForm.1b847e4d.pdf";